const TipoPagoCobranzaEnum = {
  PagoMensualidad: 6,
  AbonoMensualidad: 7,
  AbonoACapital: 8,
}

export default TipoPagoCobranzaEnum;
